import type { ReactNode } from 'react';

import { Box } from '@mui/material';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import PopupState, { bindPopper, bindToggle } from 'material-ui-popup-state';

import Button from '@/components/Buttons/Button';

import type { SxProps, Theme } from '@mui/material';
import type { PopperPlacementType } from '@mui/material/Popper';

const CustomPopper = ({
  buttonContent,
  buttonVariant,
  children,
  disabled,
  sx,
  placement = 'auto',
  buttonStyles,
  modifiers,
  zIndex = 10,
  closeOnClickInside
}: {
  buttonContent: ReactNode;
  buttonVariant: 'text' | 'outlined' | 'contained' | undefined;
  children: ReactNode;
  disabled?: boolean;
  sx?: SxProps;
  placement?: PopperPlacementType;
  buttonStyles?: SxProps<Theme>;
  modifiers?: any;
  zIndex?: number;
  closeOnClickInside?: boolean;
}) => {
  return (
    <PopupState
      popupId='demo-popup-popper'
      variant='popper'
    >
      {popupState => {
        const handleClose = () => {
          popupState.close();
        };

        return (
          <Box sx={sx}>
            <Button
              disabled={disabled}
              size='small'
              sx={{ ...buttonStyles }}
              variant={buttonVariant}
              {...bindToggle(popupState)}
            >
              {buttonContent}
            </Button>
            <Popper
              modifiers={modifiers}
              sx={{ zIndex }}
              {...bindPopper(popupState)}
              transition
              placement={placement}
            >
              {({ TransitionProps }) => (
                <Grow {...TransitionProps}>
                  <Paper sx={{ zIndex: 1 }}>
                    <ClickAwayListener onClickAway={handleClose}>
                      <Box onClick={closeOnClickInside ? handleClose : undefined}>{children}</Box>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </Box>
        );
      }}
    </PopupState>
  );
};

export default CustomPopper;
